import React from "react";
import { NavMenu } from "@shopify/app-bridge-react";
import { Link } from "react-router-dom";

export default function NavigationMenu() {
  return (
    // NavMenu registers navigation links with Shopify Admin, not the app UI.
    // Keeping a Home link enables fast client-side navigation and avoids page reloads.
    <NavMenu>
      <Link key="home" to="/" rel="home">
        Home
      </Link>
    </NavMenu>
  );
}
